import { Component, OnInit } from '@angular/core';
import { ReservationService } from 'src/app/shared/services/reservation.service';

@Component({
  selector: 'app-summary',
  templateUrl: './summary.component.html',
  styleUrls: ['./summary.component.scss']
})
export class SummaryComponent implements OnInit {
  reservation: any;

  // tslint:disable-next-line:variable-name
  constructor(private _reservation: ReservationService) { }

  ngOnInit() {
    this.reservation = this._reservation.reservation;
    console.log(this.reservation);
  }

}
